<template>
  <b-modal
    ref="modal"
    :title="`Configure ${xourceNames.pcap.extendedName} Source`"
    @ok="saveAction"
    @hidden="syncConfig"
  >
    <validation-observer ref="form">
      <validation-provider name="Sniffer Interface" rules="required" v-slot="{ errors }">
        <b-form-group label="Sniffer Interface">
          <b-form-input
            placeholder="Sniffer Interface"
            v-model="config.snifferInterface"
            :state="errors[0] ? false : null"
            class="form-control-merge"
          ></b-form-input>
          <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>
      <validation-provider name="Agent IP" rules="ipValid" v-slot="{ errors }">
        <b-form-group label="Agent IP">
          <b-form-input
            placeholder="Agent IP"
            v-model="config.agentIp"
            :state="errors[0] ? false : null"
            class="form-control-merge"
          ></b-form-input>
          <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>
      <div class="mt-2">
        <b-link
          v-b-toggle.pcap-advanced
          aria-controls="pcap-advanced"
          class="advanced-toggle"
        >
          Advanced
        </b-link>
        <b-collapse id="pcap-advanced" class="mt-2">
          <validation-provider
            name="Subnets Filter"
            rules="prefixListValid"
            v-slot="{ errors }"
          >
            <b-form-group>
              <template #label>
                Subnets Filter
                <b-icon
                  icon="info-circle"
                  class="ml-1 text-muted"
                  v-b-tooltip.hover
                  title="Filter captures to listed subnets. Add one or more subnets separated by commas."
                />
              </template>
              <b-form-input
                placeholder="Subnets Filter"
                v-model="config.subnetsFilter"
                :state="errors[0] ? false : null"
                class="form-control-merge"
              ></b-form-input>
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-collapse>
      </div>
    </validation-observer>
  </b-modal>
</template>

<script>
import configModalMixin from './configModalMixin';

export default {
  mixins: [configModalMixin],
  data() {
    return {
      config: {
        snifferInterface: '',
        agentIp: '',
        subnetsFilter: '',
      },
    };
  },
  computed: {
    postConfig() {
      // Deep copy to avoid form errors during type conversions.
      const newConfig = JSON.parse(JSON.stringify(this.config));
      if (newConfig.agentIp.length === 0) {
        newConfig.agentIp = undefined;
      }
      // Convert the textual list of subnets into an array, white-space trimmed and split by commas.
      newConfig.subnetsFilter = newConfig.subnetsFilter.replace(/\s+/g, '');
      newConfig.subnetsFilter = newConfig.subnetsFilter.length === 0
        ? []
        : newConfig.subnetsFilter.split(',');
      newConfig.enabled = true;
      return { ...this.value, ...newConfig };
    },
  },
  methods: {
    /** Sync the form fields `config` data member with the `value` prop holding the original config. */
    syncConfig() {
      const subnetsFilter = this.value.subnetsFilter || [];
      this.config = {
        snifferInterface: this.value.snifferInterface || '',
        agentIp: this.value.agentIp || '',
        subnetsFilter: subnetsFilter.join(', ') || '',
      };
    },
  },
};
</script>

<style scoped>
.advanced-toggle {
  text-decoration: underline;
}

.advanced-toggle:hover {
  cursor: pointer;
}
</style>
